import { UserLite } from '@card-software/library';

export enum BalanceSnapshotRunStatus {
  InProgress = 0,
  Completed = 1,
  Failed = 2,
}

export enum BalanceSnapshotRunType {
  Compute = 0,
  Backfill = 1,
}

export interface BalanceSnapshotRunStatusHistoryEntry {
  date: string;
  status: BalanceSnapshotRunStatus;
  user: UserLite;
  comment?: string | null;
}

/** One month computed by a run. */
export interface BalanceSnapshotRunMonth {
  year: number;
  month: number;
  locationsProcessed: number;
  snapshotDocumentsCreated: number;
  totalLotItemsCaptured: number;
  durationMs: number;
}

/** One compute or backfill of balance snapshots for one site (BalanceSnapshotRunDto). */
export interface BalanceSnapshotRun {
  id: string;
  type: BalanceSnapshotRunType;
  status: BalanceSnapshotRunStatus;
  statusHistory?: BalanceSnapshotRunStatusHistoryEntry[] | null;
  fromYear: number;
  fromMonth: number;
  toYear: number;
  toMonth: number;
  startedAt: string;
  finishedAt?: string | null;
  errorMessage?: string | null;
  months: BalanceSnapshotRunMonth[];
  siteIds?: string[] | null;
  createdBy?: string | null;
  createdDate?: string | null;
}

export interface BalanceSnapshotRunSearchCommand {
  statuses?: BalanceSnapshotRunStatus[];
  types?: BalanceSnapshotRunType[];
}

export interface BalanceSnapshotRunSearchResult {
  items: BalanceSnapshotRun[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

/** The latest month with balance snapshots for one site. */
export interface BalanceSnapshotLatest {
  siteId: string;
  year: number;
  month: number;
  computedAt: string;
  computedBy?: string | null;
}

/** The site is the request's X-Site-Id (the site picker's selection). */
export interface ComputeBalanceSnapshotCommand {
  year: number;
  month: number;
}
